import React, { useEffect } from 'react'
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { CircularProgress } from '@mui/material';
import { PageLoader } from '../../../lib/loader';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { useGetTicketCategory, useUpdateCategory } from '../api/supportapi';

const schema = yup.object().shape({
    name: yup.string()
        .required('Category is required')
});

function EditCategory({ editData, toggle }) {

    const navigate = useNavigate()

    const { data: singleCategory, isLoading } = useGetTicketCategory(editData)

    const { control, handleSubmit, formState: { errors, isValid, isDirty }, reset, setValue } = useForm({
        mode: 'onChange',
        resolver: yupResolver(schema),
        defaultValues: {
            name: ''
        }
    });

    useEffect(() => {
        fetchSingleCategory();
    }, [singleCategory]);

    const fetchSingleCategory = async () => {
        if (singleCategory) {
            setValue('name', singleCategory?.data?.data?.name);
        }
    };

    const updateCategory = useUpdateCategory();
    const onSubmit = async (data) => {
        data['id'] = editData

        const res = await updateCategory.mutateAsync({ ...data })
        if (res?.status) {
            reset()
            toggle();
            navigate('/ticket-category')
        }
    }

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            {isLoading ?
                <PageLoader /> :
                <>
                    <div className='mb-3'>
                        <h6 className="pb-2">Category</h6>
                        <Controller
                            control={control}
                            name="name"
                            render={({ field }) => (
                                <input
                                    {...field}
                                    placeholder="Enter Question"
                                    className='form-control'
                                />
                            )}
                        />
                        {errors.name?.message && <p className='m-0 errMsg'>{errors.name?.message}</p>}
                    </div>
                    <div className='d-flex justify-content-center rounded-pill'>
                        <button className='btn btn-primary d-flex align-items-center' disabled={EditCategory.isLoading || !isValid || !isDirty}>
                            {EditCategory.isLoading ?
                                <CircularProgress size={20} style={{ color: "#fff" }} className='mx-4' />
                                :
                                "Submit"}
                        </button>
                    </div>
                </>}
        </form>
    )
}

EditCategory.propTypes = {
    toggle: PropTypes.func.isRequired,
    editData: PropTypes.string.isRequired
};

export default EditCategory